import { Alert, Button, CircularProgress, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { ScrollableDialogProps } from "../Dialogs";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import SampleTable from "../SampleTable";
import { useTableColumnsProducto, useUploadFile } from "@/shared/hooks";
import { gridSizeMdLg4, plantillaExcelENUM, } from "@/shared/constants";
import { useCallback, useEffect, useRef, useState } from "react";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ButtonFileComponente from "../ButtonFileComponente";
import { Delete, Download, ErrorOutline } from "@mui/icons-material";
import { getEnvs } from "@/shared/utils";
import { IDataProducto, SerieGeneradoPorENUM } from "@/shared/interfaces";
import { getParametrosMetros, getProductoSimple } from "@/shared/actions/erp";
import CustomAutocompleteMultipleArrDynamicSearch from "../CustomAutocompleteMultipleArrDynamicSearch";
import { fetchPageSeries, getAllSeries } from "@/shared/actions/erp/productofactorserie.actions";;
import SampleTablePagination from "../SampleTablePagination";
import { openGenericObjectModal } from "../ModalGenericObject/useGenericObjectModalStore";
import { fieldSeries } from "@/shared/utils/fields-modal-generic-object";
import { useUiStore } from "@/store/ui";
import { AlertSeverityEnum } from "@/shared/interfaces";
import ModalCorreoExcedente from "./ModalCorreoExcedente";
const { VITE_API_URL_AWS, VITE_BUCKET_BASE } = getEnvs();

interface ModalInventariableUnidadProps {
  generarSerie?: boolean
  seleccionarAutomatico?: boolean
  seleccionarManual?: boolean
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  enableActionManual?: boolean
}

export default function ModalInventariableProductoFactor({
  //seleccionarAutomatico = false,
  seleccionarManual = false,
  size = gridSizeMdLg4,
  enableActionManual = true
}: ModalInventariableUnidadProps) {

  const openModalSeries = useCargarSeriesProductos(s => s.openModalSeries)
  const setOpenModalSeries = useCargarSeriesProductos(s => s.setOpenModalSeries)
  const auxRow = useCargarSeriesProductos(s => s.auxRow)
  const setAuxRow = useCargarSeriesProductos(s => s.setAuxRow)
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  //const handleSelectSeriesAutomatico = useCargarSeriesProductos(s => s.handleSelectSeriesAutomatico)
  const handleSelectManual = useCargarSeriesProductos(s => s.handleSelectManual)
  const productoFactor = useCargarSeriesProductos(s => s.productoFactor)
  const esProductoFactor = useCargarSeriesProductos(s => s.esProductoFactor)
  const setEsProductoFactor = useCargarSeriesProductos(s => s.setEsProductoFactor)
  const handleCleanSeries = useCargarSeriesProductos(s => s.handleCleanSeries)
  const handleSeriesManual = useCargarSeriesProductos(s => s.handleSeriesManual)
  const handleFileTxt = useCargarSeriesProductos(s => s.handleFileTxt)
  const handleFileExcel = useCargarSeriesProductos(s => s.handleFileExcel)
  const [visibleSeriesManual, setvisibleSeriesManual] = useState<boolean>(false);
  const [, setDataProductoFactor] = useState<IDataProducto | null>(null);
  const isLoadingUbicacionProductos = useCargarSeriesProductos(s => s.isLoadingUbicacionProductos)
  ///* series con paginador
  const paginationSeries = useCargarSeriesProductos(s => s.paginationSeries)
  const paginatedSeriesData = useCargarSeriesProductos(s => s.paginatedSeriesData)
  const setPaginationSeries = useCargarSeriesProductos(s => s.setPaginationSeries)

  // Validación de series en origen (para traslado)
  const seriesNoEncontradas = useCargarSeriesProductos(s => s.seriesNoEncontradas)
  const totalNoEncontradas = useCargarSeriesProductos(s => s.totalNoEncontradas)
  const isValidandoSeries = useCargarSeriesProductos(s => s.isValidandoSeries)
  const limpiarSeriesNoEncontradas = useCargarSeriesProductos(s => s.limpiarSeriesNoEncontradas)
  const setModoValidacion = useCargarSeriesProductos(s => s.setModoValidacion)
  // const setProductoFactor = useCargarSeriesProductos(s => s.setProductoFactor)
  const seriesDuplicadas = useCargarSeriesProductos(s => s.seriesDuplicadas)
  const totalDuplicadas = useCargarSeriesProductos(s => s.totalDuplicadas)
  const limpiarSeriesDuplicadas = useCargarSeriesProductos(s => s.limpiarSeriesDuplicadas)
  const setAlert = useUiStore(s => s.setAlert);

  const {
    columnsProductoAsociado,
    columnsCargarSeries
  } = useTableColumnsProducto();

  const {
    descargarExcelUrl,
    descargarTxtDesdeUrl
  } = useUploadFile();



  // Determinar si hay series no encontradas en origen
  const tieneSeriesNoEncontradas = totalNoEncontradas > 0;

  {/*Consultar producto para obtener productos factor*/ }
  useEffect(() => {
    async function dataProductoAsociado() {

      const resp = await getProductoSimple({
        page_size: 1,
        page: 1,
        codigo: auxRow?.producto_data?.codigo
      });

      const data = resp.data.data.at(0);

      setDataProductoFactor(data ?? null)

      if (data?.usa_metros && auxRow?.series?.length) {
        setEsProductoFactor(data?.usa_metros ?? false)
        // setProductoFactor()
        setAuxRow({
          ...auxRow!,
          es_producto_factor: data?.usa_metros ?? false,
          selected_series: auxRow?.series && auxRow.series.length > 0 ? auxRow.series : [],
          series: auxRow?.series && auxRow.series.length > 0 ? auxRow.series : [],
          serie_generado_por: SerieGeneradoPorENUM.SELECCION_MANUAL,
        })

      }

    }

    dataProductoAsociado();

    return () => {

    }
  }, [auxRow?.producto_data])

  // Establecer modo de validación a 'traslado' cuando se abre el modal
  useEffect(() => {
    const esPedidoConMetros =
    auxRow?.producto_data?.usa_metros === true &&
    auxRow?.cantidad_aprobada != null;
    //productos con check usa_metros por defecto con check seleccionado
    if (auxRow?.usa_metros || esPedidoConMetros) {
      setEsProductoFactor(true)
      setAuxRow({
        ...auxRow!,
        es_producto_factor: true,
        selected_series: auxRow?.series && auxRow.series.length > 0 ? auxRow.series : [],
        series: auxRow?.series && auxRow.series.length > 0 ? auxRow.series : []
      })
      //* reset
      setvisibleSeriesManual(auxRow?.series && auxRow.series.length > 0 ? false : true)
    }


    if (openModalSeries) {
      setModoValidacion('traslado');
    }
  }, [openModalSeries, setModoValidacion])

  //useLoaders(isLoadingUbicacionProductos);

  ///* handle

  const handleLimpiarComponente = () => {
    setAuxRow(null);
    setOpenModalSeries(false);
    setvisibleSeriesManual(false);
    handleCleanSeries();
    setEsProductoFactor(false);
    limpiarSeriesNoEncontradas();
    setModoValidacion('ingreso'); // Resetear al modo por defecto
  }

  const metrosPorSerie = useRef<Record<string, number>>({});
  const esPedido =
    auxRow?.producto_data?.usa_metros === true &&
    auxRow?.cantidad_aprobada != null; // marca de pedido (otros flujos no traen cantidad_aprobada)
  

  const fetchSeries = useCallback(
  async (query: string, page: number) => {
    if (!esPedido) {
      // flujo original intacto para otros usos
      return fetchPageSeries(query, page, {
        ubicacion: auxRow?.ubicacion_origen,
        producto: auxRow?.producto_data?.codigo,
      });
    }
    // pedido: getAllSeries para conservar metros_actuales
    const PAGE = 20;
    const res = await getAllSeries({
      serie: query || undefined,
      ubicacion: auxRow?.ubicacion_origen,
      producto: auxRow?.producto_data?.codigo,
      page,
      page_size: PAGE,
    } as any);
    const items = res.data?.data ?? [];
    items.forEach((it: any) => {
      if (it.serie) metrosPorSerie.current[it.serie] = Number(it.metros_actuales);
    });
    const options = items.map((it: any) => it.serie).filter(Boolean);
    const total = res.data?.count ?? 0;
    return { options, hasMore: page * PAGE < total };
  },
  [esPedido, auxRow?.ubicacion_origen, auxRow?.producto_data?.codigo]
);

  const [limites, setLimites] = useState({ maxExcedente: 0, minFaltante: 0 });
  useEffect(() => {
  if (openModalSeries && esPedido) {
    getParametrosMetros()
      .then(setLimites)
      .catch(() => setLimites({ maxExcedente: 0, minFaltante: 0 }));
  }
}, [openModalSeries, esPedido]);

const guardarProducto = () => {
  handleActualizarProducto(auxRow?.id!, {
    ...auxRow,
    selected_series: [],
    file_temporal: auxRow?.file_temporal,
    producto_factor: productoFactor,
  });
  handleLimpiarComponente();
};  const tieneDuplicados = totalDuplicadas > 0



  return (
    <>
      <ScrollableDialogProps
        isCloseIcon={false}
        minWidth="60%"
        onCloseIcon={() => {
          handleLimpiarComponente()
        }}
        open={openModalSeries}
        title={`Cargar Series: ${auxRow?.codigo}`}
        dialogContentText={'Seleccionar una opción para cargar series.'}
        onConfirm={() => {
          // No permitir guardar si hay series no encontradas en origen
          if (tieneSeriesNoEncontradas) return;

          const solicitado = Number(auxRow?.cantidad_metros ?? 0) || Number(auxRow?.cantidad_aprobada ?? 0);
          const asignadoFactor = (productoFactor ?? []).reduce(
            (acc: number, f: any) => acc + Number(f.cantidad_metros ?? 0), 0
          );
          const asignadoSeries = (auxRow?.series ?? []).reduce(
            (acc: number, s: string) => acc + Number(metrosPorSerie.current[s] ?? 0), 0
          );
          const asignado = asignadoFactor > 0 ? asignadoFactor : asignadoSeries;


        
          if (esPedido && solicitado > 0) {
            const minPermitido = solicitado - Number(limites.minFaltante ?? 0);
            const maxPermitido = solicitado + Number(limites.maxExcedente ?? 0);

            if (asignado < minPermitido - 0.01) {
              setAlert(true,
                `Los metros asignados (${asignado}) no pueden ser menores a ${minPermitido} (mínimo permitido).`,
                AlertSeverityEnum.error);
              return;
            }
            if (asignado > maxPermitido + 0.01) {
              setAlert(true,
                `Los metros asignados (${asignado}) no pueden superar ${maxPermitido} (máximo permitido).`,
                AlertSeverityEnum.error);
              return;
            }
          }


          // handleActualizarProducto(auxRow?.id!, {
          //   ...auxRow,
          //   selected_series: [],
          //   file_temporal: auxRow?.file_temporal,
          //   //es_producto_factor: esProductoFactor,
          //   producto_factor: productoFactor,
          //   //series: Object.values(productoFactor).map((item: any) => item.serie)
          // })
          // handleLimpiarComponente();
          const contieneSerie = auxRow?.contiene_serie === true || auxRow?.producto_data?.contiene_serie === true;
          if (esPedido && contieneSerie) {
            const requeridas = Number(auxRow?.cantidad ?? 0);
            const seleccionadas = Number(auxRow?.series?.length ?? 0);
            if (requeridas > 0 && seleccionadas < requeridas) {
              setAlert(true,
                `Debe completar ${requeridas} series para cumplir con la cantidad. Actualmente ha seleccionado ${seleccionadas}.`,
                AlertSeverityEnum.error);
              return;
            }
          }
          guardarProducto();
        }}
        confirmTextBtn={isValidandoSeries ? "Validando..." : "Guardar"}
        confirmVariantBtn="outlined"
        confirmDisabled={tieneSeriesNoEncontradas || isValidandoSeries}
        contentNode={
          <Grid container spacing={2} >

            {/*Check para cuando es producto de conversion*/}

            {/* {dataProductoFactor
              && dataProductoFactor.usa_metros && (
                <SampleCheckboxNoForm
                  label={`Cambiar conversión a METROS`}
                  defaultValue={esProductoFactor}
                  size={gridSizeMdLg12}
                  onChangeValue={(value) => {
                    setEsProductoFactor(value ?? false)
                    ///* limpiar series
                    setAuxRow({
                      ...auxRow!,
                      es_producto_factor: value ?? false,
                      selected_series: [],
                      series: []
                    })
                    //* reset
                    setvisibleSeriesManual(false)
                  }}
                />
              )
            } */}


            <Grid item {...size} container>
              <Grid item xs={11}>
                <ButtonFileComponente
                  color={'success'}
                  accept={".txt"}
                  onChange={event => {
                    setvisibleSeriesManual(false);
                    handleFileTxt(event);
                  }}
                  titulo={"TXT"} />
              </Grid>
              <Grid item xs={1}>
                <Tooltip placement="top" title='Descargar plantilla'>
                  <IconButton
                    onClick={() => descargarTxtDesdeUrl(`${VITE_API_URL_AWS}/${VITE_BUCKET_BASE}/${plantillaExcelENUM.PLANTILLA_SERIE_TXT}`, 'plantilla_serie_txt.txt')} ///*TODO: Cambiar el bucket a prod
                  >
                    <Download />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>


            <Grid item {...size} container>
              <Grid item xs={11}>
                <ButtonFileComponente
                  color={'success'}
                  accept={".xls, .xlsx"}
                  onChange={event => {
                    setvisibleSeriesManual(false)
                    handleFileExcel(event)
                  }}
                  titulo={"EXCEL"} />
              </Grid>
              <Grid item xs={1}>
                <Tooltip placement="top" title='Descargar plantilla'>
                  <IconButton
                    onClick={() => descargarExcelUrl(`${VITE_API_URL_AWS}/${VITE_BUCKET_BASE}/${plantillaExcelENUM.PLANTILLA_SERIE_EXCEL}`, 'plantilla_serie_excel.xlsx')}
                  >
                    <Download />
                  </IconButton>
                </Tooltip>
              </Grid>

            </Grid>

            {/* {seleccionarAutomatico && (
              <Grid item {...size}>
                <Button size="small"
                  style={{
                    color: 'white',
                    background: 'black'
                  }}

                  onClick={() => {
                    setvisibleSeriesManual(false);
                    handleSelectSeriesAutomatico();
                  }}
                  fullWidth variant="contained">
                  AUTOMATICO
                </Button>
              </Grid>
            ) } */}

            {
              seleccionarManual && (
                <Grid item {...size}>
                  <Button
                    fullWidth
                    size="small"
                    style={{
                      color: 'white',
                      background: 'black'
                    }}
                    variant='contained'
                    onClick={() => {
                      handleSelectManual(enableActionManual);
                      setvisibleSeriesManual(true)
                    }}
                  >
                    {'MANUAL'}
                  </Button>
                </Grid>
              )
            }

            {/* Indicador de validación en progreso */}
            {isValidandoSeries && (
              <Grid item xs={12}>
                <Alert severity="info" icon={<CircularProgress size={20} />}>
                  Validando series en la ubicación de origen...
                </Alert>
              </Grid>
            )}

            {/* Alerta de series no encontradas en origen */}
            {tieneSeriesNoEncontradas && !isValidandoSeries && (
              <Grid item xs={12}>
                <Alert
                  severity="error"
                  icon={<ErrorOutline />}
                  onClose={() => {
                    limpiarSeriesNoEncontradas();
                    setAuxRow({
                      ...auxRow!,
                      series: [],
                      file_temporal: null
                    });
                  }}
                >
                  <Typography variant="body2" fontWeight="bold">
                    Se encontraron {totalNoEncontradas} series que no existen en la ubicación de origen
                  </Typography>
                  <Typography variant="caption" component="div">
                    Las siguientes series no están disponibles en la bodega de origen seleccionada:
                  </Typography>
                  <Typography variant="caption" component="div" sx={{ mt: 0.5, fontFamily: 'monospace' }}>
                    {seriesNoEncontradas.slice(0, 10).join(', ')}
                    {seriesNoEncontradas.length > 10 && ` ... y ${seriesNoEncontradas.length - 10} más`}
                  </Typography>
                  <Typography variant="caption" component="div" sx={{ mt: 1, fontStyle: 'italic' }}>
                    Por favor, verifique que las series existan en la ubicación de origen o corrija el archivo.
                  </Typography>
                </Alert>
              </Grid>
            )}

            <Grid item xs={11}>
              <Typography variant="overline">Series:</Typography>
            </Grid>
            <Grid item xs={1}>
              <Tooltip title='Limpiar' >
                <IconButton
                  onClick={() => {
                    handleCleanSeries();
                    setvisibleSeriesManual(true)
                    limpiarSeriesDuplicadas();
                }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </Grid>

          {/* Alerta de series duplicadas */}
          {tieneDuplicados && !isValidandoSeries && (
            <Grid item xs={12}>
              <Alert
                severity="error"
                icon={<ErrorOutline />}
                onClose={() => {
                  limpiarSeriesDuplicadas();
                  setAuxRow({
                    ...auxRow!,
                    series: [],
                    file_temporal: null
                  });
                }}
              >
                <Typography variant="body2" fontWeight="bold">
                  Revisar las series ingresadas, se encontraron {totalDuplicadas} series duplicadas
                </Typography>
                <Typography variant="caption" component="div">
                  Encontramos números de serie duplicados. Por favor, verificar los registros en el sistema o revisa tu archivo antes de continuar.
                </Typography>
                <Typography variant="caption" component="div" sx={{ mt: 0.5, fontFamily: 'monospace' }}>
                  {seriesDuplicadas.slice(0, 10).join(', ')}
                  {/*{seriesDuplicadas.length > 10 && ` ... y ${seriesDuplicadas.length - 10} más`}*/}
                  <Button

                    onClick={() => {

                      openGenericObjectModal({
                        data: {
                          series: seriesDuplicadas.join(', ')
                        },
                        fields: fieldSeries,
                        title: "Series Duplicadas",
                        emptyFallback: "—",
                      });

                      // TODO: Implementar visualización completa de series
                      //console.log('Mostrar todas las series duplicadas');

                    }}
                  >
                    ... VER MÁS
                  </Button>
                </Typography>
                <Typography variant="caption" component="div" sx={{ mt: 1, fontStyle: 'italic' }}>
                  Por favor, corrija el archivo y vuelva a cargarlo.
                </Typography>
              </Alert>
            </Grid>
          )}

            {visibleSeriesManual && !isLoadingUbicacionProductos && (
              <>

                <CustomAutocompleteMultipleArrDynamicSearch
                  label="Series"
                  fetchPage={fetchSeries}
                  value={auxRow?.series ?? []}                // string[]
                  onChangeValue={(val) => {
                    handleSeriesManual(val)
                  }}
                  filterClientSide={false}
                  debounceMs={600}
                  optionLabel={
                    esPedido
                    ? (s:string) => `${s} | metros disponibles: ${metrosPorSerie.current[s] ?? '-'}`
                    : undefined
                  }
                />
              </>
            )}

            {esProductoFactor && (
              <Grid item xs={12}>
                <SampleTablePagination
                  columns={columnsProductoAsociado}
                  data={paginatedSeriesData || []}
                  rowCount={productoFactor.length}
                  setPagination={setPaginationSeries}
                  pagination={paginationSeries}
                  rowNumber={true}
                />
              </Grid>
            )}


            {
              auxRow?.series
              && !!auxRow.series.length
              && !visibleSeriesManual
              && !esProductoFactor
              &&
              (
                <>
                  {
                    auxRow.serie_generado_por == SerieGeneradoPorENUM.TXT ||
                      auxRow.serie_generado_por == SerieGeneradoPorENUM.EXCEL
                      ?
                      (
                        <Grid item xs={12}>
                          <SampleTable<any>
                            density="compact"
                            columns={columnsCargarSeries}
                            data={auxRow?.series || []}
                            enablePagination={true}
                          />
                        </Grid>
                      )
                      :
                      (
                        <Alert
                          iconMapping={{
                            success: <CheckCircleOutlineIcon fontSize="inherit" />
                          }}
                        >
                          {`Se generó por ${auxRow.serie_generado_por} la cantidad de ${auxRow?.series?.length} series con éxito.`}
                        </Alert>
                      )
                  }
                </>
              )
            }


            {/* {
              auxRow?.series
              && auxRow?.series?.length > 0
              && !visibleSeriesManual
              && !esProductoFactor
              && (
                <Alert
                  iconMapping={{
                    success: <CheckCircleOutlineIcon fontSize="inherit" />
                  }}
                >
                  {`Se generó por ${auxRow.serie_generado_por?.replace('_', ' ')} la cantidad de ${auxRow?.series?.length} series con éxito.`}
                </Alert>
              )
            } */}

            {/* {!esProductoFactor
              && !visibleSeriesManual
              && (
                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <SampleTable<any>
                      density="compact"
                      columns={columnsCargarSeries}
                      data={auxRow?.series || []}
                      enablePagination={true}
                    />

                  </Grid>
                </Grid>
              )} */}

            {/* {!esProductoFactor && (
              <>
                {!visibleSeriesManual && (
                  <Grid container item xs={12}>
                    <Grid item xs={12}>
                      <SampleTable<any>
                        density="compact"
                        columns={columnsCargarSeries}
                        data={auxRow?.series || []}
                        enablePagination={true}
                      />

                    </Grid>
                  </Grid>
                )}


              </>
            )} */}


            {/* {
              auxRow?.selected_series?.length == 0 && (
                <CustomNote
                  note="Nota: Producto no contiene series disponibles."
                />
              )
            } */}



          </Grid>
        }
      />

    </>

  )

}
